<div class="flex gap-2 items-center"
     [class.flex-col]="labelPosition === 'top' || labelPosition === 'bottom'"
     [class.flex-row]="labelPosition === 'left' || labelPosition === 'right'"
     [class.flex-col-reverse]="labelPosition === 'bottom'"
     [class.flex-row-reverse]="labelPosition === 'right'">
  @if (label) {
    <span class="text-sm text-gray-700 select-none">{{ label }}</span>
  }
  <label class="relative inline-block transition-all duration-300 ease-in-out"
         [class.opacity-50]="disabled"
         [class.cursor-not-allowed]="disabled"
         [class.cursor-pointer]="!disabled"
         [class.w-[48px]]="!isSmall"
         [class.h-[26px]]="!isSmall"
         [class.w-[34px]]="isSmall"
         [class.h-[18px]]="isSmall">
    <input type="checkbox"
           class="sr-only"
           [checked]="checked"
           [disabled]="disabled"
           (change)="toggle()" />
    <span class="absolute top-0 left-0 right-0 bottom-0 transition-all duration-300 ease-in-out"
          [class.rounded-[26px]]="!isSmall"
          [class.rounded-[18px]]="isSmall"
          [class.bg-gray-300]="!checked"
          [class.bg-red-600]="checked">
    </span>
    <span class="absolute bg-white rounded-full shadow transition-all duration-300 ease-in-out"
          [class.top-[3px]]="!isSmall"
          [class.left-[3px]]="!isSmall"
          [class.w-[20px]]="!isSmall"
          [class.h-[20px]]="!isSmall"
          [class.translate-x-[22px]]="checked && !isSmall"
          [class.top-[2px]]="isSmall"
          [class.left-[2px]]="isSmall"
          [class.w-[14px]]="isSmall"
          [class.h-[14px]]="isSmall"
          [class.translate-x-[16px]]="checked && isSmall">
    </span>
  </label>
</div>
